import { useEffect, useState } from 'react';
import { getAcctSummary } from '../../services/accountingDashboards.service';

interface AcctSummaryState {
  counts: Record<string, number>;
  totals: Record<string, number>;
  syncedAt: string | null;
  loading: boolean;
  /** True after a failed fetch; the last good counts stay on screen. */
  error: boolean;
}

/**
 * The tiles' data: one GET of ~76 bucket rows on mount and on every page tick (30s).
 * Keys absent from the cache are simply absent from `counts`, so CountPanel shows its
 * emptyValue ('—') for rows no card produces yet (Warehouse Storage, EDI).
 */
export function useAcctSummary(refreshTick: number): AcctSummaryState {
  const [state, setState] = useState<AcctSummaryState>({
    counts: {}, totals: {}, syncedAt: null, loading: true, error: false,
  });
  useEffect(() => {
    let cancelled = false;
    getAcctSummary()
      .then((res) => {
        if (cancelled) return;
        const counts: Record<string, number> = {};
        const totals: Record<string, number> = {};
        Object.entries(res.buckets ?? {}).forEach(([key, b]) => { counts[key] = b.count; totals[key] = b.total; });
        setState({ counts, totals, syncedAt: res.syncedAt ?? null, loading: false, error: false });
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('Failed to load accounting dashboard summary:', err);
        setState((s) => ({ ...s, loading: false, error: true }));
      });
    return () => { cancelled = true; };
  }, [refreshTick]);
  return state;
}
